import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RewardsPreferenceEffects } from './store/effects/rewards-preference-effects.service';
import { rewardsPreferenceReducer } from './store/reducers/rewards-preference.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('rewardsPreference', rewardsPreferenceReducer),
    EffectsModule.forFeature([RewardsPreferenceEffects]),
  ],
})
export class RewardsPreferenceModule {}
